// extracted by mini-css-extract-plugin
module.exports = {"Page":"Customers_Page__NpLGG"};